import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';

@Component({
    selector: 'ca-info-box',
    templateUrl: './info-box.component.html',
    styleUrls: ['./info-box.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoBoxComponent {
    public value = input.required<string>();
    public icon = input<string>();
    public colorVariant = input<'success' | 'error' | 'warning' | 'info'>();
}
